import {Component, Input, OnInit} from '@angular/core';
import {News} from "../../model/news.model";
import {UserDisplay, UsersServiceProvider} from "../../../core/services/users-service/users-service";

@Component({
  selector: 'app-news-icon',
  templateUrl: 'news-icon.html'
})
export class NewsIconComponent implements OnInit {
  @Input()
  news: News;

  @Input()
  size: string;

  author: UserDisplay;

  bgColor: string;
  imageUrl: string;

  constructor(
    private usersService: UsersServiceProvider
  ) {}

  ngOnInit() {
    this.author = this.usersService.getUsersProperty()[this.news.params.author];

    if(this.news.newsIcon != null) {
      this.bgColor = this.news.newsIcon.backgroundColor;
      this.imageUrl = this.news.newsIcon.icon;
    } else {
      this.imageUrl = this.author.photo;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/news/components/news-icon/news-icon.ts